import { httpGamesPlay } from "./httpGamesPlay";
const getGame = () => async () => {
    throw new Error("Game not found");
};
const saveGame = ({ httpPost }) => async (aggregateRoot) => {
    await httpGamesPlay({ httpPost })(aggregateRoot);
};
export { getGame, saveGame };
